import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileCsv,
  faFileExcel,
  faFilePdf,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import Modal from "./Modal";

const FORMAT_ICONS = {
  XLSX: faFileExcel,
  PDF: faFilePdf,
  CSV: faFileCsv,
};

const GridReportExportModal = ({
  isOpen,
  onClose,
  columns,
  format,
  onExport,
  exporting = false,
}) => {
  const { t } = useTranslation();
  const [anonymizedColumns, setAnonymizedColumns] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setAnonymizedColumns([]);
    }
  }, [isOpen, format]);

  if (!isOpen || !format) {
    return null;
  }

  const toggleColumn = (key) => {
    setAnonymizedColumns((current) =>
      current.includes(key)
        ? current.filter((columnKey) => columnKey !== key)
        : [...current, key],
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={exporting ? undefined : onClose}
      title={t("gridReports.modalTitle", {
        format: t(`gridReports.formats.${format}`),
      })}
      icon={FORMAT_ICONS[format] || faLock}
      className="grid-report-export-modal"
    >
      <p className="grid-report-export-description">
        {t("gridReports.anonymizeDescription")}
      </p>

      <div className="grid-report-column-actions">
        <button
          type="button"
          className="btn btn-default"
          disabled={exporting}
          onClick={() => setAnonymizedColumns(columns.map((column) => column.key))}
        >
          {t("gridReports.selectAll")}
        </button>
        <button
          type="button"
          className="btn btn-default"
          disabled={exporting || anonymizedColumns.length === 0}
          onClick={() => setAnonymizedColumns([])}
        >
          {t("gridReports.clearSelection")}
        </button>
      </div>

      <div className="grid-report-column-list">
        {columns.map((column) => (
          <label key={column.key} className="grid-report-column-row">
            <input
              type="checkbox"
              checked={anonymizedColumns.includes(column.key)}
              disabled={exporting}
              onChange={() => toggleColumn(column.key)}
            />
            <span>{column.label}</span>
            {anonymizedColumns.includes(column.key) && (
              <FontAwesomeIcon icon={faLock} aria-hidden="true" />
            )}
          </label>
        ))}
      </div>

      <div className="modal-footer grid-report-export-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onClose}
          disabled={exporting}
        >
          {t("common.cancel")}
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onExport(anonymizedColumns)}
          disabled={exporting || columns.length === 0}
        >
          <FontAwesomeIcon icon={FORMAT_ICONS[format] || faLock} />
          <span>
            {exporting ? t("gridReports.generating") : t("gridReports.export")}
          </span>
        </button>
      </div>
    </Modal>
  );
};

export default GridReportExportModal;
